<template>
    <div>
        <a-button class="top_btn" type="primary" v-has="'btn_add'" @click="addVisionModal()"> 添加版本 </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
            <span slot="status" slot-scope="text, record">
                <a-switch @click="onChangeStatus(record)" :checked="record.status === 1?true:false"/>
            </span>
            <span class="action" slot="action" slot-scope="text, record">
              <a @click="moduleSet(record)">模块设置</a><a-divider type="vertical"/></a>
              <a @click="controlSet(record)">控件设置</a><a-divider type="vertical"/></a>
              <a @click="pagePermissionsSet(record)">页面权限设置</a><a-divider type="vertical"/></a>
              <a @click="editVersion(record)" v-has="'btn_edit'">编辑</a><a-divider type="vertical"/></a>
              <a @click="handleDel(record)" v-has="'btn_delete'">删除</a>
            </span>
        </a-table>
        <!-- 添加版本 -->
        <AddVisionModal ref="addVisionModalRef" @submitSuccess="getList(pagination.current)"></AddVisionModal>
        <!-- 模块设置 -->
        <ModulePermissionsSet ref="modulePermissionsSetRef" @submitSuccess="getList(pagination.current)"></ModulePermissionsSet>
        <!-- 控件设置 -->
        <ControlPermissionsSet ref="controlPermissionsSetRef" @submitSuccess="getList(pagination.current)"></ControlPermissionsSet>
        <!-- 页面权限设置 -->
        <PagePermissionsSet ref="pagePermissionsSetRef" @submitSuccess="getList(pagination.current)"></PagePermissionsSet>
    </div>
</template>

<script>
import API from "./api";
import columns from "./config/columns";
import {changStatus, removeById} from "@/utils/utils"
import AddVisionModal from "./components/add-version-modal/index.vue";
import ModulePermissionsSet from "./components/module-permissions-set/index.vue";
import ControlPermissionsSet from "./components/control-permissions-set/index.vue";
import PagePermissionsSet from "./components/page-permissions-set/index.vue";
export default {
    name: 'index',
    data() {
        return {
            disabledStatus: false,
            pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
            },
            loading: true,
            editId: null,
            data: [],
            columns,
            status_list: []
        }
    },
    created() {
        this.$store.state.adminleftnavnum = "/UserBackground/KshVersionManagement"; //设置左侧导航2-2 active
        this.$nextTick(() => {
            this.disabledStatus = this.$_has('btn_status')
        });
    },
    components: {AddVisionModal, ModulePermissionsSet,ControlPermissionsSet,PagePermissionsSet},
    methods: {
        // 添加版本
        addVisionModal() {
          let _this = this;
          _this.$refs.addVisionModalRef?.open()
        },
        // 编辑
        editVersion(data) {
          let _this = this;
          _this.$refs.addVisionModalRef?.open(data)
        },
        // 模块设置
        moduleSet(data) {
          let _this = this;
          _this.$refs.modulePermissionsSetRef?.open(data)
        },
        // 控件设置
        controlSet(data) {
          let _this = this;
          _this.$refs.controlPermissionsSetRef?.open(data)
        },
        // 页面权限设置
        pagePermissionsSet(data) {
          let _this = this;
          _this.$refs.pagePermissionsSetRef?.open(data)
        },
        getList(page) {
            API.service.GET_LIST({page: page || 1}).then(res => {
              if(res.data.code == 1){
                let result = res.data.data
                this.pagination.total = result.list.total
                this.pagination.pageSize = result.list.per_page
                this.pagination.current = result.list.current_page
                this.data = result.list.data

                this.status_list = result.status_list || []
                this.loading = false
              }
            })
        },
        handleDel(data) {
          let _this = this;
          _this.$confirm({
            content: "此操作将永久删除, 是否继续?",
            icon: "exclamation-circle",
            type: 'warning',
            cancelText: '取消',
            okText: '确定',
            onOk() {
              removeById(API.service.DELE, [data.id]).then(res => {
                if (res == true) {
                  _this.getList(_this.pagination.current)
                }
              })
            },
            onCancel() {}
          });
        },
        onChangeStatus(data) {
            let status = {id: data.id, status: data.status == 2? 1: 2}
            changStatus(API.service.CHANG_STATUS, {
              status: [status]
            }).then(res => {
                if (res == true) {
                    this.getList(this.pagination.current)
                }
            })
        }
    },

    mounted() {
        this.getList()
    }
}
</script>
